import { useEffect } from 'react';
import { useAuth } from '../../hooks/AuthContext';

export const Logout = () => {
  const { signOut } = useAuth();

  useEffect(() => {
    signOut();
  }, []);
};
